import HundredBricksAPIError from '../../../HundredBricksAPIError';
class PayPaymentPlanError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('PayPaymentPlanError', ...args);
    }
}
export default PayPaymentPlanError;
